import React from 'react';
import glamorous from 'glamorous';

const XmlStructure = () => {
  return (
    <div>
      <h4>
        Structure of the codes in the XML file describing the recall
      </h4>
      <p>
        Details of the product code should be provided in the recall XML file as a complex
        structure <strong>{`<product_code>`}</strong>.
      </p>
      <div>
        <strong>The category {`<product_code>`}</strong> can contain:
        <glamorous.Ul className="pt-list" css={{ listStyle: 'disc' }}>
          <li>publication date <i>(mandatory)</i></li>
          <li>one or more classification elements: segment(s) and/or family(ies) and/or class(es)) <i>(optional)</i>
          </li>
          <li>brick <i>(optional)</i>: for each attribute, you can provide one or more attribute types and/or attribute
            values.
          </li>
        </glamorous.Ul>
      </div>
    </div>
  );
};

export default XmlStructure;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/xml-structure.js